export enum ScriptType {
    PythonV2,
    PythonV3
}